/**
 * Shared Sidebar component for authenticated screens
 */

import React from "react";
import { getInitials } from "../../utils/helpers";

export const Sidebar = ({ logoText, role, user, nav, onLogout }) => {
  return (
    <div className="fixed inset-x-0 top-0 z-40 flex border-b border-sky-100 bg-white/95 backdrop-blur lg:static lg:inset-auto lg:z-auto lg:min-h-screen lg:w-72 lg:flex-col lg:border-b-0 lg:border-r">
      <div className="flex w-full items-center justify-between px-4 py-3 lg:block lg:border-b lg:border-sky-100 lg:px-5 lg:py-5">
        <div className="text-2xl font-semibold tracking-tight text-sky-700">
          MindBridge <span>{logoText}</span>
        </div>
        <button className="rounded-full border border-rose-200 bg-rose-50 px-3 py-1.5 text-xs font-semibold text-rose-700 transition hover:bg-rose-100 lg:hidden" onClick={onLogout}>
          Sign out
        </button>
      </div>

      <div className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-2 gap-2 border-t border-sky-100 bg-white/95 px-3 py-2 pb-[calc(0.5rem+env(safe-area-inset-bottom))] backdrop-blur lg:static lg:z-auto lg:block lg:flex-1 lg:border-t-0 lg:bg-transparent lg:px-3 lg:py-4">
        <div className="hidden px-3 pb-1 text-xs font-semibold uppercase tracking-[0.14em] text-slate-500 lg:block">Workspace</div>
        {nav.map((item) => (
          <div
            key={item.id}
            className={`flex cursor-pointer items-center justify-center gap-2 rounded-xl px-3 py-2 text-xs font-semibold transition lg:mt-1 lg:justify-start lg:px-3.5 lg:py-2.5 lg:text-sm ${item.active ? "bg-sky-100 text-sky-700" : "text-slate-500 hover:bg-slate-50 hover:text-slate-700"}`}
            onClick={item.onClick}
          >
            <div className={`h-2 w-2 rounded-full ${item.status === "active" ? "bg-emerald-500" : item.status === "processing" ? "bg-amber-500" : "bg-slate-300"}`} />
            {item.label}
          </div>
        ))}
      </div>

      <div className="hidden border-t border-sky-100 px-4 py-4 lg:block">
        <div className="flex items-center gap-3 rounded-2xl bg-sky-50 p-2.5">
          <div className="grid h-9 w-9 place-items-center rounded-full border border-sky-200 bg-white text-xs font-bold text-sky-700">{getInitials(user.name)}</div>
          <div>
            <div className="text-sm font-semibold text-slate-800">{user.name}</div>
            <div className="text-xs text-slate-500">{role === "doctor" ? "Physician" : "Patient"}</div>
          </div>
        </div>
        <div className="mt-2 w-fit cursor-pointer rounded-lg px-2 py-1 text-xs font-medium text-slate-500 transition hover:bg-rose-50 hover:text-rose-700" onClick={onLogout}>
          Sign out
        </div>
      </div>
    </div>
  );
};
